

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { usePrintSettings } from "../PrintSettingsContext";

function PrintDate({ item, title }: any) {
  const dispatch = useDispatch();
  const { printAction } = usePrintSettings();

  const [cursor, setcursor] = useState("grab");
  const [psi, setpsi] = useState({ x: 0, y: 0 });
  const handleMouseDown = (e: any) => {
    setcursor("grabbing");
    setpsi({
      x: e.offsetY + item?.top,
      y: e.offsetX + item?.left,
    });
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: any) => {
    if (cursor === "grab") {
      dispatch(
        printAction({
          name: item?.title,
          target: "left",
          value: e.offsetX - psi.x,
        })
      );
      dispatch(
        printAction({
          name: item?.title,
          target: "top",
          value: e.offsetY - psi.y,
        })
      );
    }
  };

  const handleMouseUp = () => {
    setcursor("grab");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };
  return (
    <span
      style={{
        fontWeight: 600,
        position: "absolute",
        top: item?.top,
        left: item?.left,
        fontSize: item?.size,
        display: item?.show ? "block" : "none",
        whiteSpace: "nowrap",
      }}
      className={cursor}
      onMouseDown={handleMouseDown}
    >
      {title}
    </span>
  );
}

export default PrintDate;
